export default __webpack_public_path__ + "static/automation-9e71e25c1b7b2c45324377ea3d22e30c.svg";